import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}

.nav-section-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0 10px;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public activeClass(path: string) {
        const current = this.router.url;
        const isActive = current === path || current.startsWith(path + '/');
        if (isActive) {
            return 'group flex items-center gap-x-2 rounded-md bg-blue-50 px-2.5 py-1.5 text-[13px] font-semibold text-blue-700';
        }
        return 'group flex items-center gap-x-2 rounded-md px-2.5 py-1.5 text-[13px] font-medium text-gray-600 hover:text-blue-700 hover:bg-gray-100 transition-colors';
    }
}

export default ComponentNavSidebarComponent;